<div class="login-wrapper d-flex login">
  <img src="../../../assets/img/av_park_linear_green4.png" class="login_logo">
  <div class="login-border col-md-3">
    <div class="col-md-12">
      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="form-group">
          <label for="userName">{{ "i18n.base.login.userName" | translate }}</label>
          <input id="userName" type="text" class="form-control" placeholder="{{ 'i18n.base.login.userName' | translate }}"
            formControlName="userName">
          <app-error-messages [control]="loginUserNameControl"></app-error-messages>
        </div>
        <div class="form-group">
          <label for="password">{{ "i18n.base.login.password" | translate }}</label>
          <input id="password" type="password" class="form-control"
            placeholder="{{ 'i18n.base.login.password' | translate }}" formControlName="password" appPasswordVisibility>
          <app-error-messages [control]="loginPasswordControl"></app-error-messages>
        </div>
        <button type="submit" class="btn btn-primary btn-right">
          @if (loading) {
            <div class="spinner-border spinner-border-sm me-3" role="status"></div>
          }
          {{ "i18n.base.login.login" | translate }}
        </button>
        <a class="btn btn-link btn-right" [routerLink]="[forgotPasswordRoute]">
          {{ "i18n.base.login.forgot-password" | translate }}
        </a>
      </form>
    </div>
  </div>
</div>
